
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/sitemap",
      function () {
        return require("private-next-pages/products/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/sitemap"])
      });
    }
  